import { Dictionary } from "../../../../../types";
import { StoreFeature } from "../../../core/store/types";

export interface DataSource extends Dictionary<string, any>
{
    readonly typeIdentifier: string;
    readonly identifierField: string;
    readonly timingStore?: object;
    searchValue?: string;
};

export const dataSource: StoreFeature<DataSource> =
{
    getPostData: (state: DataSource, store) =>
    {
        return {
            dataSourceType: state.typeIdentifier,
            identifierField: state.identifierField,
            dataSourceParametersHash: store.hashes["dataSource"],
            dataSourceParameters: JSON.stringify(
            {
                ...state,                
                searchValue: window.skyward.extensions.encodeHtml(state.searchValue ?? "")
            }),         
        };
    }
};